import { render, staticRenderFns } from "./VehicleSelectionStepComponent.vue?vue&type=template&id=207540a6"
import script from "./VehicleSelectionStepComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleSelectionStepComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports